import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { formatNumDefault } from "../Global/tools.js";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";
import PerformanceIndicator from "../Micro/PerformanceIndicator.js";

const multiple = nota.global.multiple;

const StyledAudienceResultsBoard = styled(NanoFlex)`
  width: 100%;
  height: auto;
  .audienceResultsBoardWrapper {
    .boardColumn {
      padding-bottom: ${multiple / 2 + "px"};
      margin-right: 8px;
      background: ${nota.color.neutral.lightGrey};
      .emptySpace {
        height: ${multiple * 3 + "px"}; /* 24px */
        background: ${nota.color.neutral.white};
      }
      .boardSubtitles {
        height: ${multiple * 5 + "px"}; /* 40px */
        padding: ${multiple / 2 + "px"}; /* 4px */
        margin-top: ${multiple / 2 + "px"}; /* 4px */
        p {
          font-size: 10px;
          line-height: 12px;
        }
      }
      .boardHeader {
        height: ${multiple * 3 + "px"}; /* 24px */
        padding: ${multiple / 2 + "px"}; /* 4px */
        h4 {
          color: ${nota.color.neutral.NeuOne};
        }
      }

      .boardTitlesWrapper {
        height: ${multiple * 5 + "px"};
        margin-top: ${multiple / 2 + "px"}; /* 4px */

        .boardTitle {
          padding: ${multiple / 2 + "px"}; /* 4px */
          background-color: ${nota.color.neutral.NeuFour};
          margin-right: ${multiple / 2 + "px"};
          text-align: center;
          min-width: 32px;
          p {
            line-height: 12px;
            font-size: 12px;
          }
          &:first-child {
            margin-left: ${multiple / 2 + "px"};
            background-color: ${nota.color.neutral.white};
          }
          &:last-child {
            margin-right: 0;
          }
        }
        .secBck {
          background-color: ${nota.color.neutral.white};
        }

        .boardSubtitles {
          display: none;
        }

        .performanceResultColor {
          background-color: rgba(0, 168, 225, 0.2);
          min-width: 80px;
        }
      }
      .boardResultsWrapper {
        height: ${multiple * 5 + "px"}; /* 40px */
        margin-top: ${multiple / 2 + "px"}; /* 4px */
        .boardResult {
          padding: ${multiple / 2 + "px"}; /* 4px */
          margin-right: ${multiple / 2 + "px"};
          background-color: ${nota.color.neutral.NeuFour};
          min-width: 32px;
          &:first-child {
            margin-left: ${multiple / 2 + "px"};
            background-color: ${nota.color.neutral.white};
          }
          &:last-child {
            margin-right: 0;
          }
        }
        .secBck {
          background-color: ${nota.color.neutral.white};
        }
        .performanceResult {
          background-color: rgba(0, 168, 225, 0.2);
          position: relative;
          min-width: 80px;
          .performanceWrapper {
            position: absolute;
            bottom: -1px;
            right: -2px;
            svg {
              height: 12px;
            }
          }
        }
        .boardSubtitles {
          display: none;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .subtitlesColumn {
      max-width: 15%;
      text-align: right;
    }
  }
  .legendResults {
    margin-top: 5px;
  }
  p {
    line-height: 12px;
    font-size: 13px;
  }

  @media only screen and (max-width: ${nota.global.breakpoints.smallLaptop + "px"}) {
    /* .audienceResultsBoardWrapper {
      flex-direction: column;
      .subtitlesColumn {
        display: none;
      }
      .boardColumn {
        margin-bottom: ${multiple / 2 + "px"};
        .boardSubtitles {
          display: none;
        }
        .boardTitlesWrapper {
          .boardSubtitles {
            display: flex;
            justify-content: flex-end;
            text-align: right;
            min-width: 110px;
            p {
              padding: 2px 10px;
              width: 100%;
            }
          }
        }
        .boardResultsWrapper {
          .boardSubtitles {
            display: flex;
            justify-content: flex-end;
            text-align: right;
            min-width: 110px;
            p {
              padding: 2px 10px;
              width: 100%;
            }
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    } */
  }
  @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
    /* .audienceResultsBoardWrapper {
      flex-direction: row;
      .subtitlesColumn {
        display: flex;
      }
      .boardColumn {
        .boardSubtitles {
          display: flex;
          justify-content: flex-end;
        }
        .boardTitlesWrapper {
          .boardSubtitles {
            display: none;
          }
        }
        .boardResultsWrapper {
          .boardSubtitles {
            display: none;
          }
        }
      }
    } */
    .audienceResultsBoardWrapper {
      flex-direction: column;
      .subtitlesColumn {
        display: none;
      }
      .boardColumn {
        margin-bottom: ${multiple / 2 + "px"};
        .boardSubtitles {
          display: none;
        }
        .boardTitlesWrapper {
          .boardSubtitles {
            display: flex;
            justify-content: flex-end;
            text-align: right;
            min-width: 110px;
            p {
              padding: 2px 10px;
              width: 100%;
            }
          }
        }
        .boardResultsWrapper {
          .boardSubtitles {
            display: flex;
            justify-content: flex-end;
            text-align: right;
            min-width: 110px;
            p {
              padding: 2px 10px;
              width: 100%;
            }
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  @media only screen and (max-width: 800px) {
    .audienceResultsBoardWrapper {
      flex-direction: column;
      .subtitlesColumn {
        display: none;
      }
      .boardColumn {
        margin-bottom: ${multiple / 2 + "px"};
        .boardSubtitles {
          display: none;
        }
        .boardTitlesWrapper {
          .boardSubtitles {
            display: flex;
            justify-content: flex-end;
            text-align: right;
            min-width: 110px;
            p {
              padding: 2px 10px;
              width: 100%;
            }
          }
        }
        .boardResultsWrapper {
          .boardSubtitles {
            display: flex;
            justify-content: flex-end;
            text-align: right;
            min-width: 110px;
            p {
              padding: 2px 10px;
              width: 100%;
            }
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  @media only screen and (max-width: 345px) {
    .audienceResultsBoardWrapper {
      .boardColumn {
        .boardTitlesWrapper {
          .boardSubtitles {
            min-width: 90px;
          }
        }
        .boardResultsWrapper {
          .boardSubtitles {
            min-width: 90px;
          }
        }
      }
    }
  }
`;

const AudienceBlock = (props) => {
  let first = `${props.item.programSlotName} ${props.item.numberOfEpisodes ? `(${props.item.numberOfEpisodes} eps) ` : ""}`;
  let second = `${props.item.comparisonSlotName ? `vs ${props.item.comparisonSlotName}` : ""}${props.item.isOvernight ? " (Overnight)" : ""}`;
  // let rowTitle = `${props.item.programSlotName} ${props.item.numberOfEpisodes ? `(${props.item.numberOfEpisodes} eps) ` : ""}${props.item.comparisonSlotName ? `vs ${props.item.comparisonSlotName}` : ""}`;
  return (
    <NanoFlex className="boardSubtitles" key={"board_" + props.item.programSlotName} title={first + second} flexDirection={"column"} alignItems={"flex-end"}>
      <Type.p>
        <i>{first}</i>
      </Type.p>
      <Type.p>
        <i>{second}</i>
      </Type.p>
    </NanoFlex>
  );
};

export class AudienceResultsBoard extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    if (!this.props.data) return null;

    return (
      <StyledAudienceResultsBoard className="audienceResultsBoard" flexDirection={"column"}>
        <NanoFlex className="audienceResultsBoardWrapper" alignItems={"flex-start"}>
          {/*BOARD 1ST COLUMN WITH SUBTITLES*/}
          <NanoFlex className="boardColumn subtitlesColumn" flexDirection={"column"} alignItems={"flex-start"}>
            <NanoFlex className="emptySpace"></NanoFlex>
            <NanoFlex className="boardSubtitles">
              <Type.p>{this.translation.card.audienceResults.indicators.title}</Type.p>
            </NanoFlex>

            {this.props.data.rows.map((item, i) => {
              return <AudienceBlock key={i} item={item} />;
            })}
          </NanoFlex>

          {/*BOARD COLUMN*/}
          {this.props.data.targets.map((item) => {
            return (
              <NanoFlex className="boardColumn" flexDirection={"column"} key={"target_" + item.id}>
                {/*BOARD HEADER*/}
                <NanoFlex className="boardHeader">
                  <Type.h4>
                    <b>{item.name}</b>
                  </Type.h4>
                </NanoFlex>

                {/*BOARD TITLES*/}
                <NanoFlex className="boardTitlesWrapper">
                  {/* COPY */}
                  <NanoFlex className="boardSubtitles responsiveSubs">
                    <Type.p>{this.translation.card.audienceResults.indicators.title}</Type.p>
                  </NanoFlex>
                  {/* END COPY */}
                  {/* Rat% */}
                  {this.props.data.visibleIndicators?.includes(nota.indicators.ratPercentage) && (
                    <NanoFlex className="boardTitle secBck">
                      <Type.p>{this.translation.card.audienceResults.indicators.ratPercentage}</Type.p>
                    </NanoFlex>
                  )}
                  {/* Rat 000 */}
                  {this.props.data.visibleIndicators?.includes(nota.indicators.ratPerThousand) && (
                    <NanoFlex className="boardTitle secBck">
                      <Type.p>{this.translation.card.audienceResults.indicators.ratPerThousand}</Type.p>
                    </NanoFlex>
                  )}
                  {/* MSH% */}
                  {this.props.data.visibleIndicators?.includes(nota.indicators.marketSharePercentage) && (
                    <NanoFlex className="boardTitle performanceResultColor">
                      <Type.p>
                        <b>{this.translation.card.audienceResults.indicators.marketSharePercentage}</b> / {this.translation.card.audienceResults.indicators.slotMarketSharePercentage}
                      </Type.p>
                    </NanoFlex>
                  )}
                  {/* SLOT MSH% */}
                  {/* {this.props.data.visibleIndicators?.includes(nota.indicators.marketSharePercentage) && (
                    <NanoFlex className="boardTitle">
                      <Type.p>
                        <i>{this.translation.card.audienceResults.indicators.slotMarketSharePercentage}</i>
                      </Type.p>
                    </NanoFlex>
                  )} */}
                </NanoFlex>

                {/*BOARD RESULTS*/}
                {this.props.data.rows
                  .map((row) => {
                    return {
                      ...row,
                      rating: row.ratings.find((r) => {
                        return r.target.id == item.id;
                      }),
                    };
                  })
                  .map((row, rowIdx) => {
                    return (
                      <NanoFlex className="boardResultsWrapper" key={"TARGET_" + rowIdx + "_" + row.rating.target.id}>
                        {/* Audience Blocks Element */}
                        <AudienceBlock item={row} />
                        {/* End Audience Blocks Element */}
                        {/* Rat% */}
                        {this.props.data.visibleIndicators?.includes(nota.indicators.ratPercentage) && (
                          <NanoFlex className="boardResult secBck">
                            <Type.p>{formatNumDefault(row.rating.ratPerc, 1, 1) ?? "-"}</Type.p>
                          </NanoFlex>
                        )}
                        {/* Rat 000 */}
                        {this.props.data.visibleIndicators?.includes(nota.indicators.ratPerThousand) && (
                          <NanoFlex className="boardResult secBck">
                            <Type.p>{formatNumDefault(row.rating.ratPerThousand, 1) ?? "-"}</Type.p>
                          </NanoFlex>
                        )}
                        {/* MSH% */}
                        {(this.props.data.visibleIndicators?.includes(nota.indicators.marketSharePercentage) || this.props.data.visibleIndicators?.includes(nota.indicators.marketSharePercentage)) && (
                          <NanoFlex className="boardResult performanceResult">
                            <Type.p>
                              <b>{formatNumDefault(row.rating.shrPerc, 1, 1) ?? "-"}</b> / {formatNumDefault(row.rating.shrPercSlot, 1, 1) ?? "-"}
                            </Type.p>
                            <div className="performanceWrapper">
                              <PerformanceIndicator color={row.rating.performanceColor} />
                            </div>
                          </NanoFlex>
                        )}
                        {/* SLOT MSH% */}
                        {/* {this.props.data.visibleIndicators?.includes(nota.indicators.marketSharePercentage) && (
                          <NanoFlex className="boardResult">
                            <Type.p>
                              <i>{row.rating.shrPercSlot ? formatNumDefault(row.rating.shrPercSlot, 1, 1) : "-"}</i>
                            </Type.p>
                          </NanoFlex>
                        )} */}
                      </NanoFlex>
                    );
                  })}
              </NanoFlex>
            );
          })}
        </NanoFlex>
        {/* <NanoFlex className="legendResults" alignItems={"flex-end"} justifyContent={"flex-end"}>
        <Type.p>
          <i>Premiere based on overnight data</i>
        </Type.p>
      </NanoFlex> */}
      </StyledAudienceResultsBoard>
    );
  }
}
// Set default props
AudienceResultsBoard.defaultProps = {};

export default AudienceResultsBoard;

// --- // Documentation // --- //
/*
import AudienceResultsBoard from './../Micro/AudienceResultsBoard.js';

<AudienceResultsBoard />
*/
